<dx-popup
    [width]="400"
    [height]="170"
    [title]="title"
    [showCloseButton]="true"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
>
    <div *dxTemplate="let data of 'content'" class="lite-mode-preference-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <dx-form width="100%" height="100%" [colCount]="1">
                    <dxi-item [visible]="!!message">
                        <div *dxTemplate>
                            <span>{{ message }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item [visible]="!message">
                        <div *dxTemplate>
                            <span>Do you want us to remember your lite mode preference for {{ pageName }}?</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-check-box [(value)]="doNotPrompt" text="Do not prompt me again!"></dx-check-box>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar>
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                [width]="100"
                                text="No"
                                hint="No"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                [width]="100"
                                text="Yes"
                                hint="Yes"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
